import i18n from "../../../i18n";

export const sgT = (key, options) => i18n.t(`corePages.startGuide.${key}`, options);
